module.exports = __webpack_public_path__ + "static/img/33.3d5ed72.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/mobile/33.png
// module id = 3qW7
// module chunks = 1